var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 54,
    viewBox: "0 0 65 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00708008 23.6101L64.9944 0V12.1916L0.00708008 23.6101Z",
    fill: "#FFE400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44299 44.7811H15.9547V39.8747H7.44299V36.0091H16.8507L13.7446 30.627H0.424561V53.9992H19.1802V48.617H7.44299V44.7811ZM31.6939 30.627L27.7218 38.269L23.7198 30.627H15.9547L24.1379 44.7811V53.9992H31.1563V44.7811L39.3694 30.627H31.6939Z",
    fill: "#575756"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEy);
export default __webpack_public_path__ + "static/media/ey.0d337513.svg";
export { ForwardRef as ReactComponent };